export default {
  employee: "Werknemer",
  owner: "Eigenaar",

  subsidiary: "Dochteronderneming",
  parent: "Moeder bedrijf",
  sisterCompany: "Zuster bedrijf",
}
